export default "__VITE_ASSET__BUXSJp7c__"